import React from 'react';
import { isMobile } from 'react-device-detect';
import { InnerCardContainer } from '../../../components/Buttons/CategoryTile/styles';
import { CardContainer } from '../../../components/FolderCard/styles';
import FolderIcon from '../../../components/FolderIcon';
import { Body, BodyBold } from '../../../components/Text';
import { IShareInvitation } from '../../../services/receipts/types';
import theme from '../../../theme';
import { hashStringToColor } from '../../../util/generateRandomColor';
import { GridContainer } from '../../Onboarding/Upload/ViewDetails/EditCategories/styles';

interface ReceivedSharesGridProps {
    invitations: IShareInvitation[];
    style?: any;
    doSlice?: boolean;
    isCentered?: boolean;
    useGroupedTags?: boolean;
    groupedTags?: any;
}

const ReceivedSharesGrid: React.FC<ReceivedSharesGridProps> = ({
    invitations,
    style,
    doSlice,
    isCentered,
    useGroupedTags,
    groupedTags,
}) => {
    let tags = useGroupedTags ? groupedTags.tags : invitations;

    tags = doSlice ? tags.slice(0, tags.length > 3 ? 2 : tags.length) : tags;

    return (
        <GridContainer
            style={{
                marginBottom: 20,
                justifyContent: isCentered ? 'center' : 'flex-start',
                ...style,
            }}
        >
            {!useGroupedTags &&
                tags?.map((t: IShareInvitation) => {
                    const color = hashStringToColor(
                        t.category?.user?.id.toString()
                    );
                    return (
                        <CardContainer
                            key={t.invitation_id}
                            style={{
                                width: isMobile ? '28vw' : 150,
                                height: isMobile ? '28vw' : 150,
                                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            <InnerCardContainer>
                                <FolderIcon
                                    iconId={t.category?.icon_id || ''}
                                    size={40}
                                    // size={60}
                                />
                                <Body
                                    style={{
                                        marginTop: 15,
                                        textAlign: 'center',
                                        fontWeight: '600',
                                        fontSize: 12,
                                    }}
                                >
                                    {t.category?.name}
                                </Body>
                                <div
                                    style={{
                                        opacity: 0.5,
                                        backgroundColor: color,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: 20,
                                        height: 20,
                                        borderRadius: 10,
                                        position: 'absolute',
                                        top: 5,
                                        right: 5,
                                    }}
                                >
                                    <Body
                                        style={{
                                            color: '#FFF',
                                            fontSize: 12,
                                            marginTop: 2,
                                        }}
                                    >
                                        {t.category?.user?.first_name
                                            ?.charAt(0)
                                            .toLocaleUpperCase()}
                                    </Body>
                                </div>
                            </InnerCardContainer>
                            {/* <FolderLabel
                            style={{
                                marginTop: 10,
                                textAlign: 'center',
                                fontWeight: '600',
                            }}
                        >
                            {category.name}
                        </FolderLabel> */}
                        </CardContainer>
                    );
                })}

            {useGroupedTags &&
                tags?.map((t: any) => {
                    const color = hashStringToColor(t.tag?.user?.id.toString());
                    return (
                        <CardContainer
                            key={t.tag?.tag_id}
                            style={{
                                width: isMobile ? '28vw' : 150,
                                height: isMobile ? '28vw' : 150,
                                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            <InnerCardContainer>
                                <FolderIcon
                                    iconId={t.tag?.icon_id}
                                    folderName={t.tag?.name}
                                    size={40}
                                    // size={60}
                                />
                                <Body
                                    style={{
                                        marginTop: 15,
                                        textAlign: 'center',
                                        fontWeight: '600',
                                        fontSize: 12,
                                    }}
                                >
                                    {t.tag?.name}
                                </Body>
                                <div
                                    style={{
                                        opacity: 0.5,
                                        backgroundColor: color,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: 20,
                                        height: 20,
                                        borderRadius: 10,
                                        position: 'absolute',
                                        top: 5,
                                        right: 5,
                                    }}
                                >
                                    <Body
                                        style={{
                                            color: '#FFF',
                                            fontSize: 14,
                                        }}
                                    >
                                        {t.tag?.user?.first_name
                                            ?.charAt(0)
                                            .toLocaleUpperCase()}
                                    </Body>
                                </div>
                            </InnerCardContainer>
                            {/* <FolderLabel
                            style={{
                                marginTop: 10,
                                textAlign: 'center',
                                fontWeight: '600',
                            }}
                        >
                            {category.name}
                        </FolderLabel> */}
                        </CardContainer>
                    );
                })}

            {!useGroupedTags &&
                doSlice &&
                invitations?.length &&
                invitations?.length > 3 && (
                    <CardContainer
                        style={{
                            width: isMobile ? '28vw' : 150,
                            height: isMobile ? '28vw' : 150,
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                        }}
                    >
                        <InnerCardContainer>
                            <BodyBold
                                style={{
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: theme.colors.disabled,
                                    fontSize: isMobile ? 30 : 36,
                                    marginTop: '10%',
                                    // marginBottom: 5,
                                }}
                            >
                                +{invitations?.length - 2}
                            </BodyBold>
                            <BodyBold
                                style={{
                                    textAlign: 'center',
                                    fontWeight: '500',
                                    fontSize: isMobile ? 16 : 18,
                                }}
                            >
                                Others
                            </BodyBold>
                        </InnerCardContainer>
                    </CardContainer>
                )}
        </GridContainer>
    );
};

export default ReceivedSharesGrid;
